import React from 'react';

const ErrorPage = () => (
  <div>
    <div className="error">404</div>
    <span className="info">Oh dear something went wrong</span>
    <img alt="error message" src="http://images2.layoutsparks.com/1/160030/too-much-tv-static.gif" className="static" />
  </div>
);

export default ErrorPage;
